import { render, staticRenderFns } from "./UserAdmin.vue?vue&type=template&id=3df37f78&scoped=true&"
import script from "./UserAdmin.vue?vue&type=script&lang=ts&"
export * from "./UserAdmin.vue?vue&type=script&lang=ts&"
import style0 from "./UserAdmin.vue?vue&type=style&index=0&id=3df37f78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df37f78",
  null
  
)

export default component.exports